import React from "react";

const featureGroups = [
  [
    "Smoke alarm",
    "Carbon monoxide alarm",
    "First aid kit",
    "Self check-in with lockbox",
    "Security cameras",
  ],
  [
    "Hangers",
    "Bed linens",
    "Extra pillows & blankets",
    "Iron",
    "TV with standard cable",
  ],
  ["Refrigerator", "Microwave", "Dishwasher", "Coffee maker"],
];

export default function Features({ PropertyObject }) {

  const [features, setFeatures] = React.useState([]);

  React.useEffect(() => {
    const amenities = PropertyObject?._lstPropertyAmenities?.map(x => x.AmenitiesName) || [];
    const itemsPerGroup = Math.ceil(amenities.length / 3);
    const groupedAmenities = [
      amenities.slice(0, itemsPerGroup),
      amenities.slice(itemsPerGroup, itemsPerGroup * 2),
      amenities.slice(itemsPerGroup * 2)
    ];


    setFeatures(groupedAmenities);
  }, [PropertyObject]);

  return (
    <>
      {PropertyObject?._lstPropertyAmenities?.length > 0 && (
        <>
          <h5 className="title fw-6">Amenities and features</h5>
          <div className="wrap-feature">
            {features.map((feature, index) => (
              <div className="box-feature" key={index}>
                <ul>
                  {feature.map((item, idx) => (
                    <li className="feature-item" key={idx}>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
}
